import { DatePicker } from '@material-ui/pickers';
import React from 'react';
import { ReactComponent as Down } from 'assets/images/down.svg';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './styles.module.scss';

const _datePicker = (props) => {
  const { value, handleChange, className } = props;
  return (
    <DatePicker
      className={classNames(styles.picker, className)}
      format='DD MMM yyyy'
      disableToolbar
      disablePast
      autoOk
      variant='inline'
      value={value}
      onChange={handleChange}
      InputProps={{ endAdornment: <Down />, disableUnderline: true }}
    />
  );
};

_datePicker.propTypes = {
  value: PropTypes.oneOfType([PropTypes.elementType.isRequired, PropTypes.object.isRequired])
    .isRequired,
  handleChange: PropTypes.func.isRequired,
  className: PropTypes.string
};

_datePicker.defaultProps = {
  className: null
};

export default _datePicker;
